import React from 'react';

const LicensePage = () => {
  return (
    <div className="doc-page license">
      <h1>ライセンス</h1>

      <p>本サービス（Garlic Hamster）は、以下のオープンソースライブラリを使用しています。</p>

      <h2>使用しているライブラリ</h2>
      <ul>
        <li>@heroicons/react - MIT License</li>
        <li>@tailwindcss/postcss - MIT License</li>
        <li>@testing-library/dom - MIT License</li>
        <li>@testing-library/jest-dom - MIT License</li>
        <li>@testing-library/react - MIT License</li>
        <li>@testing-library/user-event - MIT License</li>
        <li>@types/node - MIT License</li>
        <li>@types/react - MIT License</li>
        <li>@types/react-dom - MIT License</li>
        <li>eslint - MIT License</li>
        <li>eslint-config-next - MIT License</li>
        <li>framer-motion - MIT License</li>
        <li>gsap - MIT License</li>
        <li>http-proxy-middleware - MIT License</li>
        <li>next - MIT License</li>
        <li>pixi.js - MIT License</li>
        <li>react - MIT License</li>
        <li>react-dom - MIT License</li>
        <li>react-scripts - MIT License</li>
        <li>tailwindcss - MIT License</li>
        <li>typescript - Apache-2.0 License</li>
        <li>web-vitals - Apache-2.0 License</li>
      </ul>

      

      <h2>BGM・効果音クレジット</h2>
      <ul>
        <li>BGM：<a href="https://musmus.main.jp/" target="_blank" rel="noopener noreferrer">フリーBGM・音楽素材MusMus</a></li>
        <li>BGM・効果音：<a href="https://www.springin.org/sound-stock/" target="_blank" rel="noopener noreferrer">Springin’ Sound Stock</a></li>
        <li>効果音：<a href="https://tadanote.tokyo/" target="_blank" rel="noopener noreferrer">タダノオト</a></li>
      </ul>

      <p>最終更新日：2025年12月15日</p>
    </div>
  );
};

export default LicensePage;
